/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Actual_DurationInputs */

const en_lesson_actual_duration = /** @type {(inputs: Lesson_Actual_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual duration`)
};

const he_lesson_actual_duration = /** @type {(inputs: Lesson_Actual_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`משך בפועל`)
};

/**
* | output |
* | --- |
* | "Actual duration" |
*
* @param {Lesson_Actual_DurationInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_actual_duration = /** @type {((inputs?: Lesson_Actual_DurationInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Actual_DurationInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_actual_duration(inputs)
	return he_lesson_actual_duration(inputs)
});